import React from 'react';
import Button from '../../components/Button/Button';
import classes from './styles.module.scss';

interface Props {
  title: string;
  message: string;
  primaryButtonText: string,
  secondaryButtonText: string,
  onPrimaryButtonClick: Function;
  onSecondaryButtonClick: Function;
}

const TwoButtonModal: React.SFC<Props> = props => (
  <div className={classes.modal}>
    <header>
      <h3>{props.title}</h3>
    </header>
    <div className={classes.modalContent}>{props.message}</div>
    <div className={classes.buttonBlock}>
      <Button kind="secondary" onClick={() => props.onSecondaryButtonClick()}>
        {props.secondaryButtonText}
      </Button>
      <Button kind="primary" onClick={() => props.onPrimaryButtonClick()}>
        {props.primaryButtonText}
      </Button>
    </div>
  </div>
);

export default TwoButtonModal;
